import locale from '@/locale';
import storageLocal from '@/api/storage/local';
import storageSession from '@/api/storage/session';
// set initial locale
const lang = storageLocal.getLang() || 'en';
locale(lang);
const user = storageLocal.getUserProfile();

export default {
  namespaced: true,
  state: {
    isLoggedIn: !!(user && user.id),
    lang,
    languages: [
      { code: 'en', title: 'English', abbrev: 'EN' },
      { code: 'ko', title: '한국어', abbrev: 'KR' },
    ],
    userProfile: {
      guid: user && user.guid,
      id: user && user.id,
      name: user && user.name,
      roles: user && user.roles,
      showExplorePopup: user && user.showExplorePopup,
      email: user && user.email,
      tempRoles: user && user.tempRoles,
      fillAllUserDetails: user && user.fillAllUserDetails,
      groupName: user && user.groupName,
      regdDatetime: user && user.regdDatetime,
      tempRegisteredDateTime: user && user.tempRegisteredDateTime,
    },
    isfocusonsidebar: false,
    views: storageSession.getViews(),
    appIds: storageLocal.getAppIds(),
    appTitles: storageLocal.getAppTitles(),
    noticePopup: storageLocal.getNoticePopup(),
    userDetails: storageLocal.getOtherUserDetails(),
  },
  getters: {
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    isFocusOnSidebar(state) {
      return state.isfocusonsidebar;
    },
    showExplorePopup(state) {
      state.userProfile.showExplorePopup = storageLocal.getShowExplorePopup();
      return state.userProfile.showExplorePopup;
    },
    lang(state) {
      return state.lang;
    },
    languages(state) {
      return state.languages;
    },
    userProfile(state) {
      return state.userProfile;
    },
    userRoles(state) {
      return state.userProfile.roles || [];
    },
    views(state) {
      return state.views;
    },
    hasPermit(state, getters) {
      const userRoles = getters.userRoles;
      return (svcId) => {
        const admin = 'sys_admin';
        const svcOwner = `${svcId}_owner`;
        return userRoles.includes(admin)
          || userRoles.includes(svcOwner);
      };
    },
    isEndUser(state, getters) {
      const userRoles = getters.userRoles;
      return userRoles.length === 0;
    },
    isSvcOwner(state, getters) {
      const userRoles = getters.userRoles;
      return (svcId) => {
        const svcOwner = `${svcId}_owner`;
        return userRoles.includes(svcOwner);
      };
    },
    isSysAdmin(state, getters) {
      const userRoles = getters.userRoles;
      const admin = 'sys_admin';
      return userRoles.includes(admin);
    },
    hasAuthored(state, getters) {
      const userProfile = getters.userProfile;
      return (createdBy) => {
        const userId = userProfile.id;
        return createdBy === userId;
      };
    },
    hasSeen(state, getters) {
      const seen = getters.views;
      return (comboKey) => seen.includes(comboKey);
    },
    getAppIds(state, getters) {
      const appIds = getters.appIds;
      return appIds;
    },
    getAppTitles(state, getters) {
      const appTitles = getters.appTitles;
      return appTitles;
    },
    getNoticePopup(state, getters) {
      const noticePopup = getters.noticePopup;
      return noticePopup;
    },
    getOtherUserDetails(state, getters) {
      const userDetails = getters.userDetails;
      return userDetails;
    },
  },
  mutations: {
    setLang(state, language) {
      state.lang = language;
      locale(language);
      storageLocal.setLang(language);
    },
    setUserProfile(state, payload) {
      if (payload) {
        storageLocal.setUser(payload);
        state.isLoggedIn = true;
        state.userProfile.guid = payload.guid;
        state.userProfile.id = payload.id;
        state.userProfile.name = payload.name;
        state.userProfile.roles = payload.roles;
        state.userProfile.showExplorePopup = payload.showExplorePopup;
        state.userProfile.email = payload.email;
        state.userProfile.fillAllUserDetails = payload.fillAllUserDetails;
        state.userProfile.tempRoles = payload.tempRoles;
        state.userProfile.groupName = payload.groupName;
        state.userProfile.regdDatetime = payload.regdDatetime;
        // eslint-disable-next-line max-len
        state.userProfile.tempRegisteredDateTime = payload.tempRegisteredDateTime;
      } else {
        // user logout
        storageLocal.removeUser();
        storageSession.removeViews();
        state.views = [];
        state.isLoggedIn = false;
        state.userProfile.id = '';
        state.userProfile.name = {};
        state.userProfile.roles = [];
        state.userProfile.showExplorePopup = null;
        state.userProfile.guid = null;
        state.userProfile.email = null;
        state.userProfile.fillAllUserDetails = null;
        state.userProfile.tempRoles = null;
        state.userProfile.groupName = null;
        state.userProfile.regdDatetime = null;
        state.userProfile.tempRegisteredDateTime = null;
      }
    },
    setRoles(state, roles) {
      state.userProfile.roles = roles;
    },
    setAccessToken(state, roles) {
      state.userProfile.roles = roles;
    },
    setFocusOnSidebar(state, isfocusonsidebar) {
      state.isfocusonsidebar = isfocusonsidebar;
    },
    setExplorePopUp(state, showExplorePopup) {
      state.userProfile.showExplorePopup = showExplorePopup;
      storageLocal.setShowExplorePopup(showExplorePopup);
    },
    setViews(state, comboKey) {
      state.views.push(comboKey);
      storageSession.setViews(state.views);
    },
    setAppIds(state, payload) {
      if (payload) {
        storageLocal.setAppIds(payload);
        state.appIds = payload;
      } else {
        storageLocal.setAppIds(null);
        state.appIds = [];
      }
    },
    setAppTitles(state, payload) {
      if (payload) {
        storageLocal.setAppTitles(payload);
        state.appTitles = payload;
      } else {
        storageLocal.setAppTitles(null);
        state.appTitles = [];
      }
    },
    setOtherUserDetails(state, payload) {
      if (payload) {
        storageLocal.setOtherUserDetails(payload);
        state.userDetails = payload;
      } else {
        storageLocal.setOtherUserDetails(null);
        state.userDetails = [];
      }
    },
    setNoticePopup(state, payload) {
      if (payload) {
        storageLocal.setNoticePopup(payload);
        state.noticePopup = payload;
      }
    },
  },
  actions: {
    setLang({ commit }, language) {
      commit('setLang', language);
    },
    setUserProfile({ commit }, payload) {
      commit('setUserProfile', payload);
    },
    patchUserProfile({ commit, state }, payload) {
      // add missing info to payload
      const augmentedPayload = {
        ...state.userProfile,
        ...payload,
      };
      commit('setUserProfile', augmentedPayload);
    },
    setRoles({ commit }, language) {
      commit('setRoles', language);
    },
    setFocusOnSidebar({ commit }, isfocusonsidebar) {
      commit('setFocusOnSidebar', isfocusonsidebar);
    },
    setExplorePopUp({ commit }, showExplorePopup) {
      commit('setExplorePopUp', showExplorePopup);
    },
    setViews({ commit }, comboKey) {
      commit('setViews', comboKey);
    },
    setAppIds({ commit }, appids) {
      commit('setAppIds', appids);
    },
    setAppTitles({ commit }, apptitles) {
      commit('setAppTitles', apptitles);
    },
    setNoticePopup({ commit }, payload) {
      commit('setNoticePopup', payload);
    },
    setOtherUserDetails({ commit }, payload) {
      commit('setOtherUserDetails', payload);
    },
  },
};
